export interface CliDocsEnvConfig {
  docsBaseUrl: string;
  isDevelopment: boolean;
}

export const getCliDocsEnvConfig = (): CliDocsEnvConfig => {
  const hostname = window.location.hostname;

  const isDevelopment = hostname === 'localhost' || hostname.startsWith('127.0.0.1');
  const isStaging = hostname.includes('staging');

  let docsBaseUrl: string;

  if (isDevelopment || isStaging) {
    docsBaseUrl = 'https://pre-kinsight.corp.kuaishou.com/inner-cli-docs';
  } else {
    docsBaseUrl = '/inner-cli-docs';
  }

  return {
    docsBaseUrl,
    isDevelopment,
  };
};

export const isSameOrigin = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    return urlObj.origin === window.location.origin;
  } catch {
    return false;
  }
};

export const getPageNameFromUrl = (url: string): string | null => {
  const match = url.match(/\/inner-cli-docs\/(.+?)\.html/);
  return match ? match[1] : null;
};

export const normalizeCliPage = (page?: string): string => {
  if (!page) return 'guide/introduction';

  if (page.includes('/')) {
    return page;
  }

  const pageMap: Record<string, string> = {
    introduction: 'guide/introduction',
    'quick-start': 'guide/quick-start',
  };

  return pageMap[page] || page;
};

export const getHashFromUrl = (url: string): string => {
  try {
    const urlObj = new URL(url);
    return urlObj.hash;
  } catch {
    return '';
  }
};

export const parseCliPageInfo = (url: string): { page: string | null; hash: string } => {
  const rawPage = getPageNameFromUrl(url);
  const hash = getHashFromUrl(url);

  const reversePageMap: Record<string, string> = {
    'guide/introduction': 'guide/introduction',
    'guide/quick-start': 'guide/quick-start',
    index: '',
  };

  const page = rawPage && reversePageMap[rawPage] !== undefined ? reversePageMap[rawPage] : rawPage;

  return { page, hash };
};

export const buildCliDocsUrl = (page?: string, hash?: string): string => {
  const { docsBaseUrl } = getCliDocsEnvConfig();
  const normalizedPage = normalizeCliPage(page);
  let url = `${docsBaseUrl}/${normalizedPage}.html`;

  if (hash && hash.startsWith('#')) {
    url += hash;
  }

  return url;
};

export const buildCliInternalPath = (page?: string, hash?: string): string => {
  let path: string;
  if (!page || page === 'index' || page === '') {
    path = '/cli-docs';
  } else {
    path = `/cli-docs/${page}`;
  }

  if (hash && hash.startsWith('#')) {
    path += hash;
  }

  return path;
};
